import axios, { AxiosInstance } from "axios";
import { AXIOS_TIMEOUT } from "../constants";

// const baseURL = "/api";
const baseURL =
  import.meta.env.VITE_API_BASE_URL ??
  (import.meta.env.VITE_API_BASE_URL as string);

// Create axios instance with default configurations
const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  timeout: AXIOS_TIMEOUT, // Timeout of 10 seconds
});

export default axiosInstance;
